/**
 * Default body text for the email sent to an external user when they are
 * delegated a project or work order. This is the fully admin-editable part of
 * the email; the task info box, action link, and metadata footer are appended
 * automatically by the backend (see mf-functions guestTokenApi email templates).
 *
 * Keep in sync with the server-side fallback in
 * mf-functions/functions/src/guestAccess/guestTokenApi.ts.
 */
import { GuestTaskType } from '../types/guestAccess';

/**
 * Building before title so the mail is identifiable in a crowded inbox list.
 * The building segment is dropped when no name is known.
 */
export function defaultAssignmentSubject(
    taskType: GuestTaskType,
    title: string,
    buildingName?: string
): string {
    const prefix = taskType === 'project' ? 'Inbjudan till projekt' : 'Ärende';
    return buildingName
        ? `${prefix} – ${buildingName}: ${title}`
        : `${prefix}: ${title}`;
}

export function defaultAssignmentMessage(taskType: GuestTaskType, recipientName: string): string {
    const greeting = `Hej ${recipientName || 'där'},`;
    if (taskType === 'project') {
        return `${greeting}\n\nDu har bjudits in till ett projekt via Molnfastigheter. `
            + `Information om projektet och en länk finns längst ner i detta mejl.`;
    }
    return `${greeting}\n\nDu har blivit tilldelad ett ärende via Molnfastigheter. `
        + `Information om ärendet och en länk för att visa och slutföra det finns längst ner i detta mejl.`;
}
